import type { ReaderSettings } from "@bibleunleashed/shared";

/** The `.scripture` class list for the reader's settings. Used wherever ESV text appears. */
export function scriptureClass(settings: ReaderSettings, extra = ""): string {
  return [
    "scripture",
    settings.font === "sans" && "font-sans-body",
    !settings.verseNumbers && "hide-verse-numbers",
    !settings.headings && "hide-headings",
    !settings.footnotes && "hide-footnotes",
    !settings.crossrefs && "hide-crossrefs",
    settings.redLetter && "red-letter",
    extra,
  ]
    .filter(Boolean)
    .join(" ");
}
